import React from "react";
import { SearchedContainer } from "../styled/search";
import { ProjectItem } from "./searchItems";
import { useRegex } from "../../../../hooks/useRegex";

const SearchProject = ({ data, isSearch }) => {
  const { MoneyFormat } = useRegex();

  return (
    <div className="searched">
      {isSearch && (
        <SearchedContainer>
          {data.length > 0 ? (
            <>
              <div className="label">
                {data.length > 0 && (
                  <span>
                    검색 결과
                    <strong>{MoneyFormat(data.length)}</strong>개
                  </span>
                )}
              </div>
              {data.length > 0 && data && (
                <ul>
                  {data.map((item) => (
                    <ProjectItem item={item} />
                  ))}
                </ul>
              )}
            </>
          ) : (
            <div className="noData">검색 결과가 존재하지 않습니다.</div>
          )}
        </SearchedContainer>
      )}
    </div>
  );
};

export default SearchProject;
